import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-form-opposizione-decreto-ingiuntivo-view',
  templateUrl: './form-opposizione-decreto-ingiuntivo-view.component.html',
  styleUrls: ['./form-opposizione-decreto-ingiuntivo-view.component.css']
})
export class FormOpposizioneDecretoIngiuntivoViewComponent {

  @Input() ctxBodyFascicolo;
  constructor() {}
}
